import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";

export const getMemberContractsExcel = (user: User) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getclicontrxls",
    params: {
      userid: user.userId,
      status: 1,
    },
  });
};

export default getMemberContractsExcel;
